// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".demo-drawer__content[data-v-2046c57d] {\n  padding: 0 30px;\n  padding-bottom: 86px;\n}\n.title[data-v-2046c57d] {\n  margin-bottom: 14px;\n  color: #303133;\n  font-weight: 500;\n  font-size: 14px;\n}\n.description-term[data-v-2046c57d] {\n  display: table-cell;\n  padding-bottom: 5px;\n  line-height: 20px;\n  width: 50%;\n  font-size: 14px;\n  color: #606266;\n}\n.description[data-v-2046c57d]  .el-divider--horizontal {\n  margin: 12px 0 !important;\n}", ""]);
// Exports
module.exports = exports;
